import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { IInnovationStackApiOperation } from '../models/IInnovationStackApiOperation';
import { IInnovationStackRequest } from '../models/IInnovationStackRequest';
import { IInnovationStackResponse } from '../models/IInnovationStackResponse';
import { IInnovationStackRequestLog } from '../models/IInnovationStackRequestLog';
import { Utility } from '../helpers/utility';

const promiseFrom = lastValueFrom;

export class InnovationStackApis implements IInnovationStackApiOperation {
  private constructor(
    private readonly httpClient: HttpClient,
    private readonly apiV1: string,
    private readonly apiV2: string
  ) {}

  public static innovationStackApiOperation(
    httpClient: HttpClient,
    apiV1: string,
    apiV2: string
  ): IInnovationStackApiOperation {
    return new InnovationStackApis(httpClient, apiV1, apiV2);
  }

  public async createInnovationStack(
    request: IInnovationStackRequest,
    clientId: number
  ): Promise<IInnovationStackResponse> {
    const url = Utility.buildURL({
      url: `${this.apiV1}/innovation-stack`,
      queryParameters: { clientId: clientId.toString() }
    });

    return promiseFrom(
      this.httpClient.post<IInnovationStackResponse>(url, request)
    );
  }

  public async getInnovationStackRequestLogs(): Promise<
    IInnovationStackRequestLog[]
  > {
    const url = Utility.buildURL({
      url: `${this.apiV1}/innovation-stack/request-logs`
    });

    return promiseFrom(this.httpClient.get<IInnovationStackRequestLog[]>(url));
  }
}
